import findSecondaryReadingPaneTabById from '../utils/findSecondaryReadingPaneTabById';
import { AsyncSendState } from 'owa-mail-compose-store';
import { onInlineComposeSendStateChange } from 'owa-mail-compose-actions';
import { isSxSDisplayed } from 'owa-sxs-store';
import { lazyActivateTab, lazyCloseTab, lazySetTabIsShown } from 'owa-tab-store';
import { orchestrator } from 'satcheljs';

export default orchestrator(onInlineComposeSendStateChange, actionMessage => {
    const { viewState } = actionMessage;

    if (isSxSDisplayed()) {
        return;
    }

    const tab = viewState && findSecondaryReadingPaneTabById(viewState.conversationId);
    if (tab) {
        switch (viewState.asyncSendState) {
            case AsyncSendState.None:
                lazySetTabIsShown.importAndExecute(tab, true /* isShown */);
                lazyActivateTab.importAndExecute(tab);
                break;

            case AsyncSendState.Delay:
                lazySetTabIsShown.importAndExecute(tab, false /* isShown */);
                break;

            default:
                // Sending, Sent, Closed, Timeout, Error
                lazyCloseTab.importAndExecute(tab);
                break;
        }
    }
});
